import React from 'react'
import styled from 'styled-components'

import { PractitionerSettings } from '../../../../../../lib/practitioner-settings/types'
import { PayoutsProgram } from './PayoutsProgram'

import greenInformationCircle from '../../../../../../img/green-information-circle.svg'

const StyledAlertContainer = styled.div`
  font-size: 14px;
  line-height: 1.25;
  border-radius: 8px;
  padding: 11px 15px;
  margin-bottom: 20px;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: flex-start;
  background-color: #48a2b01a;
  color: ${({ theme }) => theme.colors.grayscale.black};
`

const StyledAlertIconWrapper = styled.div`
  display: flex;
  align-self: center;
  margin-right: 15px;
  width: 25px;
`

const StyledAlertIcon = styled.img`
  width: 100%;
`

const StyledAlertContent = styled.div`
  width: 100%;
`

export interface PayoutsProgramSectionProps {
  settings: PractitionerSettings
}

const PayoutsProgramSection: React.FC<PayoutsProgramSectionProps> = ({ settings }) => {
  return (
    <div>
      <h3 className="small-h3">Payouts</h3>
      <PayoutsProgram settings={settings} />
      <StyledAlertContainer>
        <StyledAlertIconWrapper>
          <StyledAlertIcon src={greenInformationCircle} />
        </StyledAlertIconWrapper>
        <StyledAlertContent>
          Automatic payouts are processed monthly when your earnings exceed $200.
        </StyledAlertContent>
      </StyledAlertContainer>
    </div>
  )
}

export default PayoutsProgramSection
